import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import message from "./slice/message";
import date from "./slice/date";
import columnFilter from "./slice/columnFilter";
import { api } from "./service/api";
import filterSlice from "./slice/filterSlice";
import columnVisibilitySlice from "./slice/visiblleColumns";
import menuTypeReducer from "./slice/menuType";

const reducers = combineReducers({
    message: message,
    api: api.reducer,
    date: date,
    filters: filterSlice,
    menuType: menuTypeReducer,
    columnFilter: columnFilter,
    columnVisibilitySlice: columnVisibilitySlice,
});

const rootReducer = (state, action) => reducers(state, action);

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(api.middleware),
});
setupListeners(store.dispatch);

export { store };
